// Module
var code = "<div style=\"position:relative\"> <div ng-transclude> </div> <div ng-show=\"!showContent\" class=\"missingRightsOverlay\"> Sie verfügen nicht über ausreichende Berechtigungen zur Betrachtung und Nutzung dieses Inhaltes. </div> </div>";
// Exports
module.exports = code;